import { styled } from '@vw-marketing/us-components';

interface StyledTweetWrapperProps {
  opacity?: boolean;
}
export const StyledTweetWrapper: any = styled.div<StyledTweetWrapperProps>`
  width: 100%;
  margin-top: 15px;
  margin-left: 2px;
  .opacity-wrapper {
    position: absolute;
    width: calc(100% + 2px);
    height: 100%;
    top: -1px;
    right: -1px;
    background-color: white;
    opacity: 0.5;
    z-index: 1;
  }
  .twitter-tweet {
    width: 100% !important;
    max-width: 100% !important;
  }
`;
